module.exports = __webpack_public_path__ + "static/img/image_wl.0d30176.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/flag/image_wl.png
// module id = wl+2
// module chunks = 1